var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142 154",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ehhh61ztp__clip0_57191_12235)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ehhh61ztp__filter0_f_57191_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1467 79.7858V147.367L75.1017 147.412L22.5431 124.934L22.498 124.858V57.2812L22.5431 57.3623L75.0971 79.8398L75.1467 79.7858Z",
    fill: "url(#ehhh61ztp__paint0_linear_57191_12235)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ehhh61ztp__filter1_d_57191_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1469 79.7858L63.6018 101.241L36.5748 88.9941L16.4453 79.7858L22.4982 57.2812L22.5433 57.3623L75.0973 79.8398L75.1469 79.7858Z",
    fill: "url(#ehhh61ztp__paint1_linear_57191_12235)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ehhh61ztp__filter2_f_57191_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.791 57.2588L127.745 57.3399L75.1914 79.8174V147.394L127.745 124.916L127.791 124.835V57.2588Z",
    fill: "url(#ehhh61ztp__paint2_linear_57191_12235)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ehhh61ztp__filter3_f_57191_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.08 57.7725L127.035 57.8535L74.4805 80.331L80.6269 101.754L110.61 88.804L131.162 80.331L127.08 57.7725Z",
    fill: "url(#ehhh61ztp__paint3_linear_57191_12235)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ehhh61ztp__filter4_f_57191_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.746 57.2861L75.1916 34.8086H75.1015L22.543 57.2861V57.3401L75.097 79.8176L127.746 57.2861Z",
    fill: "#E6FFFB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.828 130.777L89.6879 136.394L76.5527 142.02M89.6879 127.412L76.5527 133.034",
    stroke: "url(#ehhh61ztp__paint4_linear_57191_12235)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ehhh61ztp__filter5_f_57191_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ehhh61ztp__paint5_linear_57191_12235)",
    d: "M75.6113 35.1602L75.6113 71.1962"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ehhh61ztp__filter6_f_57191_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B5F5EC",
    fillOpacity: 0.5,
    d: "M71.2723 150.00712A33.8739 2.88288 0 1 0 71.2723 155.77288A33.8739 2.88288 0 1 0 71.2723 150.00712Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ehhh61ztp__filter0_f_57191_12235",
    x: 18.498,
    y: 53.2812,
    width: 60.6484,
    height: 98.1309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_57191_12235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ehhh61ztp__filter1_d_57191_12235",
    x: 8.44531,
    y: 57.2812,
    width: 74.7012,
    height: 59.9595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0745098 0 0 0 0 0.760784 0 0 0 0 0.760784 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_57191_12235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_57191_12235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ehhh61ztp__filter2_f_57191_12235",
    x: 73.1914,
    y: 55.2588,
    width: 56.5986,
    height: 94.1353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_57191_12235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ehhh61ztp__filter3_f_57191_12235",
    x: 73.4805,
    y: 56.7725,
    width: 58.6816,
    height: 45.9819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_57191_12235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ehhh61ztp__filter4_f_57191_12235",
    x: 16.543,
    y: 28.8086,
    width: 117.203,
    height: 57.0088,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_57191_12235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ehhh61ztp__filter5_f_57191_12235",
    x: 74.1113,
    y: 34.1602,
    width: 3,
    height: 38.0361,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_57191_12235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ehhh61ztp__filter6_f_57191_12235",
    x: 29.3984,
    y: 142.007,
    width: 83.748,
    height: 21.7656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_57191_12235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ehhh61ztp__paint0_linear_57191_12235",
    x1: 23.2188,
    y1: 93.5379,
    x2: 75.1107,
    y2: 122.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5F5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FAF2",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ehhh61ztp__paint1_linear_57191_12235",
    x1: 75.1109,
    y1: 79.8442,
    x2: 12.4082,
    y2: 73.3578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5F5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEFFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ehhh61ztp__paint2_linear_57191_12235",
    x1: 96.0114,
    y1: 65.4299,
    x2: 101.056,
    y2: 136.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13C2C2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6EDEDA",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FAF2",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ehhh61ztp__paint3_linear_57191_12235",
    x1: 127.733,
    y1: 57.2951,
    x2: 79.4446,
    y2: 99.8176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87E8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7F3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ehhh61ztp__paint4_linear_57191_12235",
    x1: 76.5527,
    y1: 137.502,
    x2: 103.94,
    y2: 125.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6FFFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ehhh61ztp__paint5_linear_57191_12235",
    x1: 74.6113,
    y1: 35.1602,
    x2: 74.6113,
    y2: 71.1962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87E8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7F3ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ehhh61ztp__clip0_57191_12235"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4.48047 7.77246)",
    d: "M0 0H144.144V144.144H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImg);
export default __webpack_public_path__ + "static/media/emptyImg.618e9a0765247e4f261639826db5cfa1.svg";
export { ForwardRef as ReactComponent };